import { render } from "./SubscriptionDetails.vue?vue&type=template&id=55cea774&scoped=true&ts=true"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=ts"

import "./SubscriptionDetails.vue?vue&type=style&index=0&id=55cea774&scoped=true&lang=scss"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cea774"]])

export default __exports__